import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import AnimatedBackground from '../AnimatedBackground/AnimatedBackground';
import './About.css';
import { GridBackground } from '../Background/AnimatedBackground';

const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const fadeInUp = {
    hidden: { opacity: 0, y: 60 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.25, 0.4, 0.25, 1] },
    },
  };

  return (
    <section id="about" className="about" ref={ref}>
      
      <div className="container">
        <motion.div
          initial="hidden"
          animate={inView ? 'visible' : 'hidden'}
          variants={fadeInUp}
        >
          <h2 className="section-title">Pioneering Industrial Excellence</h2>
          <p className="section-subtitle">
            Empowering businesses with world-class automation and intelligent engineering solutions
          </p>
        </motion.div>

        <div className="about-grid">
          <motion.div
            className="about-card"
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            variants={fadeInUp}
            transition={{ delay: 0.2 }}
          >
            <div className="card-icon">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                <circle cx="30" cy="30" r="28" fill="url(#aboutGrad1)" opacity="0.2"/>
                <path d="M30 10 L35 20 L45 22 L37 30 L39 40 L30 35 L21 40 L23 30 L15 22 L25 20 Z" fill="#0071e3"/>
                <defs>
                  <linearGradient id="aboutGrad1" x1="0" y1="0" x2="60" y2="60">
                    <stop offset="0%" stopColor="#0071e3"/>
                    <stop offset="100%" stopColor="#bf5af2"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h3>Our Mission</h3>
            <p>
              To revolutionize manufacturing and industrial processes through innovative automation 
              technologies, AI-driven insights, and cutting-edge IoT solutions that drive efficiency, 
              productivity, and sustainable growth.
            </p>
          </motion.div>

          <motion.div
            className="about-card"
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            variants={fadeInUp}
            transition={{ delay: 0.3 }}
          >
            <div className="card-icon">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                <circle cx="30" cy="30" r="28" fill="url(#aboutGrad2)" opacity="0.2"/>
                <circle cx="30" cy="30" r="15" stroke="#bf5af2" strokeWidth="3" fill="none"/>
                <circle cx="30" cy="30" r="5" fill="#0071e3"/>
                <path d="M30 15 L30 10 M30 50 L30 45 M15 30 L10 30 M50 30 L45 30" stroke="#bf5af2" strokeWidth="2"/>
                <defs>
                  <linearGradient id="aboutGrad2" x1="0" y1="0" x2="60" y2="60">
                    <stop offset="0%" stopColor="#bf5af2"/>
                    <stop offset="100%" stopColor="#0071e3"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h3>Our Approach</h3>
            <p>
              We combine deep industry expertise with state-of-the-art technology to deliver 
              customized solutions. From initial consultation to deployment and ongoing support, 
              we ensure seamless integration and measurable results.
            </p>
          </motion.div>

          <motion.div
            className="about-card"
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            variants={fadeInUp}
            transition={{ delay: 0.4 }}
          >
            <div className="card-icon">
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
                <circle cx="30" cy="30" r="28" fill="url(#aboutGrad3)" opacity="0.2"/>
                <path d="M20 30 L27 37 L40 20" stroke="#30d158" strokeWidth="4" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="30" cy="30" r="20" stroke="#30d158" strokeWidth="2" fill="none"/>
                <defs>
                  <linearGradient id="aboutGrad3" x1="0" y1="0" x2="60" y2="60">
                    <stop offset="0%" stopColor="#30d158"/>
                    <stop offset="100%" stopColor="#0071e3"/>
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <h3>Our Promise</h3>
            <p>
              Delivering excellence in every project with industry-leading response times, 
              24/7 support, and a commitment to innovation. We don't just meet expectations—we 
              exceed them through continuous improvement and partnership.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
